<template>
  <div :class="`lookbook-grid-${styleClassVariant}`">
    <div class="lg:flex-1 lg:relative">
      <!-- TODO Dynamic alt tag (e.g. Campaign photo Glory)-->
      <OImage
        img-class="lookbook-main-image w-full md:mb-5 md:rounded md:mt-24"
        :desktop="heroImage.desktop"
        :mobile="heroImage.mobile"
        :src="heroImage.fallback"
        :alt="$t('Accessibilty.AltTags.CampaignPhoto')"
      />
      <Socials class="hidden lookbook-socials" />
    </div>
    <div class="lookbook-secondary-content-container lg:flex-1">
      <div class="lookbook-secondary-content lg:flex">
        <div class="lg:flex-1">
          <div class="md-responsive-square">
            <div class="md-responsive-square-content">
              <div class="custom-padding pt-20 relative md:rounded md:h-full" :style="{ 'background-color': color }">
                <h4
                  v-if="slogan"
                  class="text-white ota-title text-center mb-12"
                  v-text="slogan"
                />
                <!-- TODO Dynamic alt tag (e.g. Packaging Glory)-->
                <OImage
                  img-class="absolute packaging-image mx-auto left-0 right-0"
                  :desktop="packagingImage.desktop"
                  :mobile="packagingImage.mobile"
                  :src="packagingImage.fallback"
                  :alt="$t('Accessibilty.AltTags.Package')"
                />
              </div>
            </div>
          </div>
        </div>
        <ReadyToTry class="pt-5 mt-24 md:hidden" @click="$emit('click')" />
        <VideoComponent
          v-if="hasVideo"
          class="lookbook-video mt-20 lg:flex-1 md:mt-5 lg:ml-5 lg:mt-0"
          :video-source="videoSource"
          :placeholder-image="placeholderImage"
        />
        <div
          v-else
          :class="['lg:flex-1 relative lg:my-0 mb-40', {
            'lg:mb-5 mt-12 md:mt-5': isMenOneVariant,
            'lg:ml-5 mt-24': !isMenOneVariant
          }]"
        >
          <OImage
            img-class="w-full h-full object-cover lg:rounded "
            v-bind="squareImage"
            :alt="$t('Accessibilty.AltTags.ProductImage')"
          />
          <Socials
            :class="['desktop-socials px-5 w-full', {
              'lg:hidden': isMenOneVariant
            }]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Orientations } from '@/enums/products'
const OImage = () => import('@/components/OImage')
const VideoComponent = () => import('@/components/VideoComponent')
const ReadyToTry = () => import('@/components/ReadyToTry')
const Socials = () => import('@/components/Socials')

export default {
  name: 'LookbookGrid',
  components: {
    OImage,
    VideoComponent,
    Socials,
    ReadyToTry
  },
  props: {
    heroImage: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    videoSource: {
      type: String,
      default: ''
    },
    placeholderImage: {
      type: String,
      default: ''
    },
    packagingImage: {
      type: Object,
      default: () => ({})
    },
    slogan: {
      type: String,
      default: '3, 2, 1 Action!'
    },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', ...Object.values(Orientations)].some(variant => variant === value)
    },
    hasVideo: {
      type: Boolean,
      default: false
    },
    squareImage: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isMenOneVariant () {
      return this.variant === Orientations.menone
    },

    styleClassVariant () {
      return this.variant === Orientations.menone ? 'menOne' : 'default'
    }
  }
}
</script>

<style lang="postcss" scoped>
.desktop-socials {
  @apply absolute;
  bottom: -14.5rem;
}

.oimage >>> img {
  max-width: 100%;
}

.custom-padding {
  padding-bottom: 25.6rem;
}

>>> .packaging-image {
  top: 14.5rem;
  max-height: 38.2rem;
}

@screen md {
  .md-responsive-square {
    @apply block relative;
    content: "";
    padding-bottom: 100%;
  }

  >>> .responsive-square {
    @apply rounded overflow-hidden;
  }

  .md-responsive-square-content {
    @apply absolute w-full h-full;
  }
}

@screen md {
  >>> .packaging-image {
    max-height: unset;
  }

  .desktop-socials {
    bottom: -5.5rem;
  }
}

@screen lg {
  .lookbook-grid-menOne {
    @apply flex mt-24;

    >>> .lookbook-main-image {
      @apply mt-0 mb-0 h-full object-cover;
    }

    .lookbook-socials {
      @apply block absolute w-full px-5;
      bottom: -8.3rem;
    }

    .lookbook-secondary-content-container {
      @apply ml-5;
    }

    .lookbook-secondary-content {
      @apply flex-col-reverse h-full;
    }

    >>> .responsive-square, .md-responsive-square {
      @apply h-full;

      video {
        @apply object-fill;
      }

      &:after {
        content: none;
      }

      > div {
        @apply relative;
      }
    }

    >>> .md-responsive-square {
      @apply pb-0;
    }

    .lookbook-video {
      @apply ml-0 mb-5;

      >>> .negative-margin {
        @apply hidden;
      }
    }
  }

  .desktop-socials {
    bottom: -5.5rem;
  }

  >>> .packaging-image {
    top: 16rem;
  }
}
</style>
